import AppLoader from "./AppLoader";
import PostsLoader from "./PostsLoader";
import FiltersLoader from "./FiltersLoader";
import Spinner from "./Spinner";

export { AppLoader, PostsLoader, FiltersLoader, Spinner };
